import { render, staticRenderFns } from "./formMsg.vue?vue&type=template&id=62614289"
import script from "./formMsg.vue?vue&type=script&lang=js"
export * from "./formMsg.vue?vue&type=script&lang=js"
import style0 from "./formMsg.vue?vue&type=style&index=0&id=62614289&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports